module.exports = __webpack_public_path__ + "static/media/up-arrow.f23f0810.svg";